import $http from '@/api/index'
import qs from 'qs'
//判断是否可启用和启动作废状态
export function StartObjectByType(obj) {
  let options = {
    method: 'POST',
    url: 'DMS/startObjectByType',
    requestType: 2
  }
  return $http(options, obj)
}
//登记未知设备成功 删除未登记状态
export function UpdateUnKnownDeviceState(obj) {
  let options = {
    method: 'POST',
    url: 'DMS/UpdateUnKnownDeviceState',
    requestType: 2
  }
  return $http(options, obj)
}
//查询操作记录
export function GetAllObjHasOperateHis(pageIndex, pageSize) {
  let options = {
    method: 'GET',
    url: 'DMS/getAllObjHasOperateHis',
    requestType: 2
  }
  let params = {
    pageIndex: pageIndex,
    pageSize: pageSize
  }
  return $http(options, params)
}
//查询具体操作详情
export function GetObjOperateRecord(devid, devType) {
  let options = {
    method: 'GET',
    url: 'DMS/getObjOperateRecord',
    requestType: 2
  }
  let params = {
    devid: devid,
    devType: devType
  }
  return $http(options, params)
}
export function GetAllPlatfrom() {
  let options = {
    method: 'GET',
    url: 'TMS/GetAllPlatfrom',
    requestType: 2
  }
  let params = {}
  return $http(options, params)
}
export function SelectObjectByType(id, type, typeCode) {
  let options = {
    method: 'GET',
    url: 'dms/selectObjectByType',
    requestType: 2
  }
  let params = {
    id: id,
    type: type,
    typeCode: typeCode
  }
  return $http(options, params)
}
//精确搜索哪些客户机已经授权并展示授权列表
export function GetHostPortPowerInfoListBySearchPamaWeb(pageindex, pagesize, pamaweb) {
  let options = {
    method: 'GET',
    url: 'basedata/GetHostPortPowerInfoListBySearchPamaWeb',
    requestType: 2
  }
  let params = {
    pageindex: pageindex,
    pagesize: pagesize,
    pamaweb: pamaweb
  }
  return $http(options, params)
}
//精确搜索哪些客户机未授权并展示授权列表
export function GetPubHostListByNoPortPowerSearchPamaWeb(pageindex, pagesize, pamaweb) {
  let options = {
    method: 'GET',
    url: 'basedata/GetPubHostListByNoPortPowerSearchPamaWeb',
    requestType: 2
  }
  let params = {
    pageindex: pageindex,
    pagesize: pagesize,
    pamaweb: pamaweb
  }
  return $http(options, params)
}
//模糊查找客户机USB端口已授权统计
export function GetHostPortPowerInfoByVagueWeb(pageindex, pagesize, importchar) {
  let options = {
    method: 'GET',
    url: 'basedata/GetHostPortPowerInfoByVagueWeb',
    requestType: 2
  }
  let params = {
    pageindex: pageindex,
    pagesize: pagesize,
    importchar: importchar
  }
  return $http(options, params)
}
//模糊查找客户机USB端口未授权统计
export function GetPubHostListByNoPortPowerSearchVagueWeb(pageindex, pagesize, importchar) {
  let options = {
    method: 'GET',
    url: 'basedata/GetPubHostListByNoPortPowerSearchVagueWeb',
    requestType: 2
  }
  let params = {
    pageindex: pageindex,
    pagesize: pagesize,
    importchar: importchar
  }
  return $http(options, params)
}
//通过MAC或者IP自动补全MAC,IP
export function GetUnKnownDevMacIpByMacOrIp(mac, ip, tipsNum) {
  let options = {
    method: 'GET',
    url: 'DMS/GetUnKnownDevMacIpByMacOrIp',
    requestType: 2
  }
  let params = {
    mac: mac,
    ip: ip,
    tipsNum: tipsNum
  }
  return $http(options, params)
}

//根据精确搜索的条件查找静态IP设备
export function GetStaticIpBindMasterByExact(strInfo) {
  let options = {
    method: 'GET',
    url: 'DMS/GetStaticIpBindMasterByExact',
    requestType: 2
  }
  let params = {
    pama: strInfo
  }
  return $http(options, params)
}
//操作静态设备加入保留后 返回的状态记录到对应的表中
export function UpdateStaticIpBindState(obj) {
  let options = {
    method: 'POST',
    url: 'DMS/UpdateStaticIpBindState',
    requestType: 2
  }
  return $http(options, obj)
}
//g根据MAC获取设备信息
export function getMac(mac) {
  let options = {
    method: 'GET',
    url: 'user/GetHost',
    requestType: 2
  }
  let params = {
    mac: mac
  }
  return $http(options, params)
}
//添加自定义功能按钮
export function AddHostIconUserInfo(formData) {
  let options = {
    method: 'post',
    url: 'TMS/AddHostIconUserInfo',
    requestType: 2,
    isFormData: true
  }
  return $http(options, formData)
} //
//获取个人配置的功能按钮列表
export function GetHostIconUserConfigListByUserid(userId) {
  let options = {
    method: 'GET',
    url: 'TMS/GetHostIconUserConfigListByUserid',
    requestType: 2
  }
  let params = {
    userId: userId
  }
  return $http(options, params)
}
//获取所有配置的功能按钮列表
export function GetHostIconConfigList() {
  let options = {
    method: 'GET',
    url: 'TMS/GetHostIconConfigList',
    requestType: 2
  }
  let params = {}
  return $http(options, params)
}
//上传功能图标
export function UpdateHostIconConfigWeb(formData) {
  let options = {
    method: 'post',
    url: 'TMS/UpdateHostIconConfigWeb',
    requestType: 2,
    isFormData: true
  }
  return $http(options, formData)
}
//修改客户机信息
export function UpdateHost(formData) {
  let options = {
    method: 'post',
    url: 'basedata/UpdateHost',
    requestType: 2,
    isFormData: true
  }
  return $http(options, formData)
}
//模糊搜索客户机
export function GetPubHostListByVagueWeb(pageindex, pagesize, importchar) {
  let options = {
    method: 'GET',
    url: 'basedata/GetPubHostListByVagueWeb',
    requestType: 2
  }
  let params = {
    pageindex: pageindex,
    pagesize: pagesize,
    importchar: importchar
  }
  return $http(options, params)
}
//添加客户机计划（多种类）
export function AddOperatePlanInfo(formData) {
  let options = {
    method: 'post',
    url: 'TMS/AddOperatePlanInfo',
    requestType: 2,
    isFormData: true
  }
  return $http(options, formData)
}
//添加客户机计划（新）单一的
export function AddSimpleOperatePlanInfo(formData) {
  let options = {
    method: 'post',
    url: 'TMS/AddSimpleOperatePlanInfo',
    requestType: 2,
    isFormData: true
  }
  return $http(options, formData)
}
//文件分发
export function AddFileDistributionInfo(formData, onUploadProgress) {
  let options = {
    method: 'post',
    url: 'TMS/AddFileDistributionInfo',
    requestType: 2,
    isFormData: true,
    onUploadProgress: onUploadProgress
  }
  return $http(options, formData)
}
//软件分发
export function AddSoftDistributionInfo(formData) {
  let options = {
    method: 'post',
    url: 'TMS/AddSoftDistributionInfo',
    requestType: 2,
    isFormData: true
  }
  return $http(options, formData)
}
//系统备份
export function AddOpSystemBakRestoreInfo(formData) {
  let options = {
    method: 'post',
    url: 'TMS/AddOpSystemBakRestoreInfo',
    requestType: 2,
    isFormData: true
  }
  return $http(options, formData)
}
//获取软件列表
export function GetAllSourceProgram() {
  let options = {
    method: 'GET',
    url: 'TMS/GetAllSourceProgram',
    requestType: 2
  }
  let params = {}
  return $http(options, params)
}
//根据类型获取软件列表
export function GetAllProgramInfoByServicetype(servicetype) {
  let options = {
    method: 'GET',
    url: 'TMS/GetAllProgramInfoByServicetype?servicetype=' + servicetype,
    requestType: 2
  }
  let params = {}
  return $http(options, params)
}
//获取计划列表
export function GetOperateionPlanList(userid) {
  let options = {
    method: 'GET',
    url: 'TMS/GetOperateionPlanList?userid=' + userid,
    requestType: 2
  }
  let params = {}
  return $http(options, params)
}
//获取计划列表
export function GetOperationPlanInfoList(userid) {
  let options = {
    method: 'GET',
    url: 'TMS/GetOperationPlanInfoList?userid=' + userid,
    requestType: 2
  }
  let params = {}
  return $http(options, params)
}
//获取明细
export function GetOperatePlanDetailInfoByMasterid(masterid) {
  let options = {
    method: 'GET',
    url: 'TMS/GetOperatePlanDetailInfoByMasterid?masterid=' + masterid,
    requestType: 2
  }
  let params = {}
  return $http(options, params)
}

//获取执行步骤
export function GetOperationDetailLogInfoByDetailId(detailid, masterid, Hostmac) {
  let options = {
    method: 'GET',
    url: 'TMS/GetOperationDetailLogInfoByDetailId',
    requestType: 2
  }
  let params = {
    detailid: detailid,
    masterid: masterid,
    Hostmac: Hostmac
  }
  return $http(options, params)
}
//获取详细执行日志
export function GetOperationDetailLogListByBusinessMasterid(masterid) {
  let options = {
    method: 'GET',
    url: 'TMS/GetOperationDetailLogListByBusinessMasterid',
    requestType: 2
  }
  let params = {
    masterid: masterid
  }
  return $http(options, params)
}
//获取执行进度
export function GetStateCountByMasterId(masterid) {
  let options = {
    method: 'GET',
    url: 'TMS/GetStateCountByMasterId',
    requestType: 2
  }
  let params = {
    masterid: masterid
  }
  return $http(options, params)
}
//获取统计信息（共享文件夹）
export function GetHostShareNetFolderListByMasterid(masterid, hostmac) {
  let options = {
    method: 'GET',
    url: 'TMS/GetHostShareNetFolderListByMasterid',
    requestType: 2
  }
  let params = {
    masterid: masterid,
    hostmac: hostmac
  }
  return $http(options, params)
}
//获取统计信息（浏览器）
export function GetHostRegeditInfoListByMasterid(masterid, hostmac) {
  let options = {
    method: 'GET',
    url: 'TMS/GetHostRegeditInfoListByMasterid',
    requestType: 2
  }
  let params = {
    masterid: masterid,
    hostmac: hostmac
  }
  return $http(options, params)
}
//再次执行
export function AgainExcuteDistributionInfo(jobj) {
  let options = {
    method: 'POST',
    url: 'TMS/AgainExcuteDistributionInfo',
    requestType: 2
  }
  let params = {}
  return $http(options, jobj)
}
//获取统计信息（进程）
export function GetHostProcessInfoListByMasterid(masterid, hostmac) {
  let options = {
    method: 'GET',
    url: 'TMS/GetHostProcessInfoListByMasterid',
    requestType: 2
  }
  let params = {
    masterid: masterid,
    hostmac: hostmac
  }
  return $http(options, params)
}
//编辑计划
export function ModidyOperationInfo(formData) {
  let options = {
    method: 'post',
    url: 'TMS/ModidyOperationInfo',
    requestType: 2,
    isFormData: true
  }
  return $http(options, formData)
}
//获取所有操作系统
export function GetHostOstypeList() {
  let options = {
    method: 'GET',
    url: 'basedata/GetHostOstypeList',
    requestType: 2
  }
  let params = {}
  return $http(options, params)
}
//获取所有客户机分类
export function GetSoftSortList() {
  let options = {
    method: 'GET',
    url: 'TMS/GetSoftSortList',
    requestType: 2
  }
  let params = {}
  return $http(options, params)
}
//获取软件类别
export function GetAllProgramType() {
  let options = {
    method: 'GET',
    url: 'TMS/GetAllProgramType',
    requestType: 2
  }
  let params = {}
  return $http(options, params)
}
//模糊搜索软件
export function GetProgramListVaugeByName(programname) {
  let options = {
    method: 'GET',
    url: 'TMS/GetProgramListVaugeByName',
    requestType: 2
  }
  let params = {
    programname: programname
  }
  return $http(options, params)
}
//获取所有软件类别（新版）
export function GetProgramTypeListWeb() {
  let options = {
    method: 'GET',
    url: 'TMS/GetProgramTypeListWeb',
    requestType: 2
  }
  let params = {}
  return $http(options, params)
}
//获取软件类型根据类别（新版）
export function GetProgramTypeListByTypeWeb(type) {
  let options = {
    method: 'GET',
    url: 'TMS/GetProgramTypeListByTypeWeb',
    requestType: 2
  }
  let params = {
    type: type
  }
  return $http(options, params)
}
//获取软件列表（新版）
export function GetPublishProgramListByType(TypeName) {
  let options = {
    method: 'GET',
    url: 'TMS/GetPublishProgramListByType',
    requestType: 2
  }
  let params = {
    TypeName: TypeName,
    ProgramServiceType: 1
  }
  return $http(options, params)
}
//获取软件列表根据二级（新版）
export function GetPublishProgramByProgramSeriviceType(TypeId) {
  let options = {
    method: 'GET',
    url: 'TMS/GetPublishProgramByProgramSeriviceType',
    requestType: 2
  }
  let params = {
    ProgramType: TypeId,
    ProgramServiceType: 1
  }
  return $http(options, params)
}
//获取所有客户机类型
export function GetSoftTypeList() {
  let options = {
    method: 'GET',
    url: 'TMS/GetSoftTypeList',
    requestType: 2
  }
  let params = {}
  return $http(options, params)
} //
//根据安装包名称获取对应的信息
export function GetProgramInfoMationByInstallPackageName(installpackagename) {
  let options = {
    method: 'GET',
    url: 'TMS/GetProgramInfoMationByInstallPackageName',
    requestType: 2
  }
  let params = {
    installpackagename: installpackagename
  }
  return $http(options, params)
}
// 根据上传软件ID获取对应的操作系统
export function GetSoftofOsListbySoftid(softid) {
  let options = {
    method: 'GET',
    url: 'TMS/GetSoftofOsListbySoftid',
    requestType: 2
  }
  let params = {
    softid: softid
  }
  return $http(options, params)
} //
//添加软件到库中
export function AddProgramInfomationByWeb(formData, onUploadProgress) {
  let options = {
    method: 'post',
    url: 'TMS/AddProgramInfomationByWeb',
    requestType: 2,
    isFormData: true,
    onUploadProgress: onUploadProgress
  }
  return $http(options, formData)
}
//根据软件ID集合删除对应的软件
export function deletePrograminfoByIdListWeb(idlist) {
  let options = {
    method: 'post',
    url: 'TMS/deletePrograminfoByIdListWeb?idlist=' + idlist,
    requestType: 2
  }
  let params = {}
  return $http(options, params)
}
//根据客户机mac 获取远程截屏
export function RemoteCapture(target) {
  let options = {
    method: 'GET',
    url: 'im/RemoteCapture',
    requestType: 2
  }
  let params = {
    target: target
  }
  return $http(options, params)
}
//根据客户机mac获取其进程信息
export function RemoteProcessInfo(target) {
  let options = {
    method: 'GET',
    url: 'im/RemoteProcessInfo',
    requestType: 2
  }
  let params = {
    target: target
  }
  return $http(options, params)
}

//根据客户机mac获取其服务信息
export function RemoteServiceInfo(target) {
  let options = {
    method: 'GET',
    url: 'im/RemoteServiceInfo',
    requestType: 2
  }
  let params = {
    target: target
  }
  return $http(options, params)
}
//根据客户机mac及进程id 结束进程信息
export function KillProcessInfoByPid(target, pid) {
  let options = {
    method: 'GET',
    url: 'im/KillProcessInfoByPid',
    requestType: 2
  }
  let params = {
    target: target,
    pid: pid
  }
  return $http(options, params)
}
//根据客户机mac 及服务名称 停止服务
export function StopServiceInfoByName(target, servicename) {
  let options = {
    method: 'GET',
    url: 'im/StopServiceInfoByName',
    requestType: 2
  }
  let params = {
    target: target,
    servicename: servicename
  }
  return $http(options, params)
}

//根据客户机mac及服务名称启动服务
export function StartServiceInfoByName(target, servicename) {
  let options = {
    method: 'GET',
    url: 'im/StartServiceInfoByName',
    requestType: 2
  }
  let params = {
    target: target,
    servicename: servicename
  }
  return $http(options, params)
}

// 根据客户机mac及服务名称重启服务
export function ReStartServiceInfoByName(target, servicename) {
  let options = {
    method: 'GET',
    url: 'im/ReStartServiceInfoByName',
    requestType: 2
  }
  let params = {
    target: target,
    servicename: servicename
  }
  return $http(options, params)
}
export function SetServiceModeByType(target, servicename, stype) {
  let options = {
    method: 'GET',
    url: 'im/SetServiceModeByType',
    requestType: 2
  }
  let params = {
    target: target,
    servicename: servicename,
    stype: stype
  }
  return $http(options, params)
}

export function RemoteCmd(target, cmdinfo) {
  let options = {
    method: 'GET',
    url: 'im/RemoteCmd',
    requestType: 2
  }
  let params = {
    target: target,
    cmdinfo: cmdinfo
  }
  return $http(options, params)
}
//区域
export function GetAllAreaTable() {
  let options = {
    method: 'GET',
    url: 'basedata/GetAllAreaTable',
    requestType: 2
  }
  let params = {}
  return $http(options, params)
}
//楼
export function GetAllBuildTableByAreaname(areaname) {
  let options = {
    method: 'GET',
    url: 'basedata/GetAllBuildTableByAreaname',
    requestType: 2
  }
  let params = {
    areaname: areaname
  }
  return $http(options, params)
}
//层
export function GetAllFloorTable(areaname, buildname) {
  let options = {
    method: 'GET',
    url: 'basedata/GetAllFloorTable',
    requestType: 2
  }
  let params = {
    areaname: areaname,
    buildname: buildname
  }
  return $http(options, params)
}
//房间
export function GetAllRoomTable(areaname, buildname, floorname) {
  let options = {
    method: 'GET',
    url: 'basedata/GetAllRoomTable',
    requestType: 2
  }
  let params = {
    areaname: areaname,
    buildname: buildname,
    floorname: floorname
  }
  return $http(options, params)
}
//添加运维设备
export function CreateSimpleDev(devInfo) {
  let options = {
    method: 'POST',
    url: 'DMS/CreateSimpleDev',
    requestType: 2
  }
  let params = {
    devInfo: devInfo
  }
  return $http(options, devInfo)
}
//删除指定运维设备
export function deleteSimpleDev(ID) {
  let options = {
    method: 'GET',
    url: 'DMS/DeleteSimpleDev',
    requestType: 2
  }
  let params = {
    ID: ID
  }
  return $http(options, params)
}
//getSimpleDev获取设备详情
export function getSimpleDev(ID) {
  let options = {
    method: 'GET',
    url: 'DMS/getSimpleDev',
    requestType: 2
  }
  let params = {
    devId: ID
  }
  return $http(options, params)
}
//获取监控参数
export function GetMonitorPamaInfoListByDevice(deviceId, deviceType) {
  let options = {
    method: 'GET',
    url: 'DMS/GetMonitorPamaInfoListByDevice',
    requestType: 2
  }
  let params = {
    deviceId: deviceId,
    deviceType: deviceType
  }
  return $http(options, params)
}
//获取报警信息
export function GetMonitorAlarmInfoListByDevice(deviceId, deviceType, datasetname, alarmlevelname, begintime, endtime) {
  let options = {
    method: 'GET',
    url: 'DMS/GetMonitorAlarmToTaskInfoListByDevice',
    requestType: 2
  }
  let params = {
    deviceId: deviceId,
    deviceType: deviceType,
    datasetname: datasetname,
    alarmlevelname: alarmlevelname,
    begintime: begintime,
    endtime: endtime
  }
  return $http(options, params)
}
//获取日志字段
export function GetDictionaryByTableName(tablename) {
  let options = {
    method: 'GET',
    url: 'MMS/GetDictionaryByTableName',
    requestType: 2
  }
  let params = {
    tablename: tablename
  }
  return $http(options, params)
}
//获取日志字段详细信息
export function GetResultDYInfo(tablename, fieldname) {
  let options = {
    method: 'GET',
    url: 'JOB/GetResultDYInfo',
    requestType: 2
  }
  let params = {
    tablename: tablename,
    fieldname: fieldname
  }
  return $http(options, params)
}
//获取日志详细信息
export function GetHisMonitorInfoByDeviceID(tablename, jobname, deviceid, devicetype, dtbegintime, dtendtime) {
  let options = {
    method: 'GET',
    url: 'MMS/GetHisMonitorInfoByDeviceID',
    requestType: 2
  }
  let params = {
    tablename: tablename,
    jobname: jobname,
    deviceid: deviceid,
    devicetype: devicetype,
    dtbegintime: dtbegintime,
    dtendtime: dtendtime,
  }
  return $http(options, params)
}

//获取报警明细数据
export function GetMonitorAlarmDetailInfoList(alarmdetailid, datasetname, condition, alarmlevel, excuteusername,
  excutestate) {
  let options = {
    method: 'GET',
    url: 'DMS/GetMonitorAlarmDetailInfoList',
    requestType: 2
  }
  let params = {
    alarmdetailid: alarmdetailid,
    datasetname: datasetname,
    condition: condition,
    alarmlevel: alarmlevel,
    excuteusername: excuteusername,
    excutestate: excutestate
  }
  return $http(options, params)
}
//获取操作系统信息
export function GetOperSystemInfoDto(osid) {
  let options = {
    method: 'GET',
    url: 'DMS/GetOperSystemInfoDto',
    requestType: 2
  }
  let params = {
    osid: osid
  }
  return $http(options, params)
}
//获取应用信息
export function GetVWProgramByProgId(progId) {
  let options = {
    method: 'GET',
    url: 'TMS/GetVWProgramByProgId',
    requestType: 2
  }
  let params = {
    progId: progId
  }
  return $http(options, params)
}
//获取服务信息
export function GetServiceGeneralInfoExById(ServiceId) {
  let options = {
    method: 'GET',
    url: 'TMS/GetServiceGeneralInfoExById',
    requestType: 2
  }
  let params = {
    ServiceId: ServiceId
  }
  return $http(options, params)
}
//获取设备关联任务
export function GetTaskByDeviceId(deviceId, deviceType, TaskType, ExcuteUserId, TaskState, CreateTime1, CreateTime2) {
  let options = {
    method: 'POST',
    url: 'task/GetTaskByDeviceId',
    requestType: 2
  }
  let params = {
    DeviceId: deviceId,
    DeviceType: deviceType,
    TaskType: TaskType,
    ExcuteUserId: ExcuteUserId,
    TaskState: TaskState,
    CreateTime1: CreateTime1,
    CreateTime2: CreateTime2
  }
  return $http(options, params)
}
//获取所有一级类型
export function GetAllFirstLevelList() {
  let options = {
    method: 'GET',
    url: 'basedata/GetAllFirstLevelList',
    requestType: 2
  }
  let params = {}
  return $http(options, params)
}
//获取一级类型对应二级
export function GetRelationListByFirstLevel(id) {
  let options = {
    method: 'GET',
    url: 'basedata/GetRelationListByFirstLevel',
    requestType: 2
  }
  let params = {
    id: id
  }
  return $http(options, params)
}
//获取所有未关联
export function GetNotRelationList() {
  let options = {
    method: 'GET',
    url: 'basedata/GetNotRelationList',
    requestType: 2
  }
  let params = {}
  return $http(options, params)
}
//建立关联
export function setObjectCodeMapping(id, typeList) {
  let options = {
    method: 'POST',
    url: 'basedata/setObjectCodeMapping',
    requestType: 2
  }
  let params = {
    objId: id,
    objTypeList: typeList
  }
  return $http(options, params)
}
//获取未监控数据
export function GetUnMonitorDeviceList() {
  let options = {
    method: 'GET',
    url: 'basedata/GetUnMonitorDeviceList',
    requestType: 2
  }
  let params = {}
  return $http(options, params)
}
//获取未知设备数据
export function GetUnKnowDevInfo(keyWord, currentstate, pageIndex, pageSize) {
  let options = {
    method: 'GET',
    url: 'DMS/GetUnKnowDevInfo',
    requestType: 2
  }
  let params = {
    pama: JSON.stringify({
      Tyzf: keyWord,
      CurrentState: currentstate,
      PageNum: pageIndex,
      PageRecord: pageSize
    })
  }
  return $http(options, params)
}
//获取未知设备数据
export function GetUnKnownDevInfoByExact(myParams) {
  let options = {
    method: 'GET',
    url: 'DMS/GetUnKnownDevInfoByExact',
    requestType: 2
  }
  let params = {
    pama: myParams
  }
  return $http(options, params)
}
//添加忽略设备
export function AddUnMonitorDeviceIgnore(formData) {
  let options = {
    method: 'post',
    url: 'DMS/AddUnMonitorDeviceIgnore',
    requestType: 2,
    isFormData: true
  }
  return $http(options, formData)
}
//添加忽略设备
export function GetIgNoreDeviceList() {
  let options = {
    method: 'GET',
    url: 'basedata/GetIgNoreDeviceList',
    requestType: 2
  }
  let params = {}
  return $http(options, params)
}
export function GetUnKnowDevSearchPath(ip, mac) {
  let options = {
    method: 'GET',
    url: 'DMS/GetUnKnowDevSearchPath',
    requestType: 2
  }
  let params = {
    ip: ip,
    mac: mac,
    id: 0,
    guid: '',
  }
  return $http(options, params)
}
export function GetUnKnownDeviceDetail(mac) {
  let options = {
    method: 'GET',
    url: 'DMS/GetUnKnownDeviceDetail',
    requestType: 2
  }
  let params = {
    mac: mac
  }
  return $http(options, params)
}
//未知设备移除网络
export function RemoveAuthEx(devInfo) {
  let options = {
    method: 'POST',
    url: 'DHCP/RemoveAuthEx',
    requestType: 2
  }
  let params = {
    devInfo: devInfo
  }
  return $http(options, devInfo)
}
//未知设备移除网络后添加任务
export function RemoveUnKnownDeviceInfoToNet(jobj) {
  let options = {
    method: 'POST',
    url: 'DMS/RemoveUnKnownDeviceInfoToNet',
    requestType: 2
  }
  let params = {}
  return $http(options, jobj)
}
//创建登记任务
export function CreateUnKnownDeviceTask(formData) {
  let options = {
    method: 'post',
    url: 'DMS/CreateUnKnownDeviceTask',
    requestType: 2,
    isFormData: true
  }
  return $http(options, formData)
}
//探测详情
export function GetHisRecordByMac(mac, sourcetype) {
  let options = {
    method: 'GET',
    url: 'DMS/GetHisRecordByMac',
    requestType: 2
  }
  let params = {
    mac: mac,
    sourcetype: sourcetype
  }
  return $http(options, params)
}
//快速备注未知设备
export function MemoUnknownDevice(jobj) {
  let options = {
    method: 'POST',
    url: 'DMS/MemoUnknownDevice',
    requestType: 2
  }
  let params = {}
  return $http(options, jobj)
}
//快速查询未知设备
export function GetUnKnownDeviceById(jobj) {
  let options = {
    method: 'POST',
    url: 'DMS/GetUnKnownDeviceById',
    requestType: 2
  }
  let params = {}
  return $http(options, jobj)
}
//探测详情GetUnInstallHshComputer
export function LoadRemoteDirectory(mac, path) {
  let options = {
    method: 'GET',
    url: 'im/LoadRemoteDirectory',
    requestType: 2
  }
  let params = {
    target: mac,
    path: path
  }
  return $http(options, params)
}
//获取未安装Hsh客户机
export function GetUnInstallHshComputer(mac, ip, name, location, port, time, currentstate) {
  let options = {
    method: 'GET',
    url: 'DMS/GetUnInstallHshComputer',
    requestType: 2
  }
  let params = {
    mac: mac,
    ip: ip,
    switchname: name,
    switchlocation: location,
    portdesc: port,
    LastUpdateTime: time,
    currentstate: currentstate,
  }
  return $http(options, params)
}
//搜索链路完整性报表
export function GetUnCompleteLink(searchclass, iscompletelink) {
  let options = {
    method: 'GET',
    url: 'DMS/GetUnCompleteLink',
    requestType: 2
  }
  let params = {
    searchclass: searchclass,
    iscompletelink: iscompletelink
  }
  return $http(options, params)
}
//搜索链路完整性报表1
export function GetUnCompleteLink1(searchclass, iscompletelink, nodekey) {
  let options = {
    method: 'GET',
    url: 'DMS/GetUnCompleteLink',
    requestType: 2
  }
  let params = {
    searchclass: searchclass,
    iscompletelink: iscompletelink,
    nodekey: nodekey
  }
  return $http(options, params)
}
//未安装客户端忽略DHCP
export function RemoveUnInstallHshDevice(jobj) {
  let options = {
    method: 'POST',
    url: 'DMS/RemoveUnInstallHshDevice',
    requestType: 2
  }
  let params = {}
  return $http(options, jobj)
}
//获取忽略历史lastupdatetime
export function GetRemoveUnInstallHshComputerWeb(mac, ip, name, location, port, time, taskstate, opstate, opuername,
  optime) {
  let options = {
    method: 'GET',
    url: 'DMS/GetRemoveUnInstallHshComputerWeb',
    requestType: 2
  }
  let params = {
    mac: mac,
    ip: ip,
    switchname: name,
    switchlocation: location,
    portdesc: port,
    lastupdatetime: time,
    taskstate: taskstate,
    opstate: opstate,
    opuername: opuername,
    optime: optime,
  }
  return $http(options, params)
}
//获取正在使用的计算机组信息
export function GetEnableGroupInformation() {
  let options = {
    method: 'GET',
    url: 'TMS/GetEnableGroupInformation',
    requestType: 2
  }
  let params = {}
  return $http(options, params)
}
//TODO:新增计算机组
export function AddGroup(groupInfomation) {
  let getUrl = {
    method: 'POST',
    url: 'TMS/AddGroup',
    requestType: 2
  }
  let params = groupInfomation
  return $http(getUrl, params)
}
//TODO:修改计算机组
export function UpdateGroup(groupInfomation) {
  let getUrl = {
    method: 'POST',
    url: 'TMS/UpdateGroup',
    requestType: 2
  }
  let params = groupInfomation
  return $http(getUrl, params)
}
//删除计算机组详情
export function DeleteGroupinfo(groupid) {
  let getUrl = {
    method: 'POST',
    url: 'TMS/DeleteGroupinfo' + '?groupid=' + groupid,
    requestType: 2
  }
  let params = ""
  return $http(getUrl, params)
}
//根据组ID获取对应的客户机
export function GetGroupHostListByGroupId(groupid) {
  let options = {
    method: 'GET',
    url: 'TMS/GetGroupHostListByGroupId',
    requestType: 2
  }
  let params = {
    groupid: groupid
  }
  return $http(options, params)
}
//增加组对应的计算机
export function UpdateGroupHostInfo(jobj) {
  let options = {
    method: 'POST',
    url: 'TMS/UpdateGroupHostInfo',
    requestType: 2
  }
  let params = {}
  return $http(options, jobj)
}
//删除组对应的计算机
export function DeleteGroupHostInfo(jobj) {
  let options = {
    method: 'POST',
    url: 'TMS/DeleteGroupHostInfo',
    requestType: 2
  }
  let params = {}
  return $http(options, jobj)
}
//获取远程服务器上的文件列表
export function GetRootFileTreeDirectoryList() {
  let options = {
    method: 'GET',
    url: 'TMS/GetRootFileTreeDirectoryList',
    requestType: 2
  }
  let params = {}
  return $http(options, params)
}
//获取文件下载id
export function GetAttachFileIdByMainId(mainid) {
  let options = {
    method: 'GET',
    url: 'TMS/GetAttachFileIdByMainId',
    requestType: 2
  }
  let params = {
    mainid: mainid,
    filetype: 401
  }
  return $http(options, params)
}
//获取所有组策略
export function GetAllGroupPolicy() {
  let options = {
    method: 'GET',
    url: 'TMS/GetAllGroupPolicy',
    requestType: 2
  }
  let params = {}
  return $http(options, params)
}
//获取策略明细
export function GetGpFuncListByInfoId(gpid) {
  let options = {
    method: 'GET',
    url: 'TMS/GetGpFuncListByInfoId',
    requestType: 2
  }
  let params = {
    gpid: gpid
  }
  return $http(options, params)
}
//获取计划列表（分页）
export function GetOperationPlanInfoListBySearchParam(pageindex, pagesize, searchparam) {
  let options = {
    method: 'GET',
    url: 'TMS/GetOperationPlanInfoListBySearchParam',
    requestType: 2
  }
  let params = {
    pageindex: pageindex,
    pagesize: pagesize,
    searchparam: searchparam
  }
  return $http(options, params)
}
//获取计划列表（分页）
//export function GetOperationPlanInfoListBySearchParam(pageindex,pagesize,searchparam) {
//	let options = {
//		method: 'GET',
//		url: 'TMS/GetOperationPlanInfoListBySearchParam',
//		requestType: 2
//	}
//	let params = {
//		pageindex:pageindex,
//		pagesize:pagesize,
//		searchparam:searchparam
//	}
//	return $http(options, params)
//}
//未知设备移除网络后添加任务
export function ChangeClientType(jobj) {
  let options = {
    method: 'POST',
    url: 'TMS/ChangeClientType',
    requestType: 2
  }
  let params = {}
  return $http(options, jobj)
}
//删除计划
export function DeleteOperatePlanById(Id) {
  let options = {
    method: 'POST',
    url: 'TMS/DeleteOperatePlanById?Id=' + Id,
    requestType: 2
  }
  let params = {}
  return $http(options, params)
}
//修改升级方式
export function UpdatePubHostUpdateModeByMaclist(jobj) {
  let options = {
    method: 'POST',
    url: 'basedata/UpdatePubHostUpdateModeByMaclist',
    requestType: 2
  }
  let params = {}
  return $http(options, jobj)
}
/**
 * 当前客户机的key
 */
export function GetRedCoralKey() {
  let options = {
    method: 'GET',
    url: 'TMS/GetRedCoralKey',
    requestType: 2
  }
  let params = {}
  return $http(options, params)
}

/**
 * 增加和修改软件下载次数
 */
export function AddOrUpdateSoftDownInfo(softid) {
  let options = {
    method: 'POST',
    url: 'TMS/AddOrUpdateSoftDownInfo?softid=' + softid,
    requestType: 2
  }
  let params = {}
  return $http(options, params)
}

/**
 * 增加和修改软件下载次数
 */
export function GetSoftDownLoadInfoList() {
  let options = {
    method: 'GET',
    url: 'TMS/GetSoftDownLoadInfoList',
    requestType: 2
  }
  let params = {}
  return $http(options, params)
}
/**
 * 根据主机MAC获取对应的联系人,以分号分隔，如：张三;13677111177;合肥市蜀山区兴科大厦18楼101室
 */
export function GetLinkManPhoneLocation(hostmac) {
  let options = {
    method: 'GET',
    url: 'TMS/GetLinkManPhoneLocation',
    requestType: 2
  }
  let params = {
    hostmac: hostmac
  }
  return $http(options, params)
}
//未知设备忽略
export function IngnoreUnKnownDeviceInfo(jobj) {
  let options = {
    method: 'POST',
    url: 'DMS/IngnoreUnKnownDeviceInfo',
    requestType: 2
  }
  let params = {}
  return $http(options, jobj)
}
//获取未知设备导出数据源
export function GetAllSearchUnKnownDeviceList(searchparam) {
  let options = {
    method: 'GET',
    url: 'DMS/GetAllSearchUnKnownDeviceList',
    requestType: 2
  }
  let params = {
    pama: searchparam
  }
  return $http(options, params)
}
//获取未知设备导出数据源（模糊）
export function GetAllSearchUnKnownDeviceVagueList(inputchar) {
  let options = {
    method: 'GET',
    url: 'DMS/GetAllSearchUnKnownDeviceVagueList',
    requestType: 2
  }
  let params = {
    inputchar: inputchar,
    currentstate: 0
  }
  return $http(options, params)
}
//导出选中
export function GetUnKnownDeviceListByMacList(jobj) {
  let options = {
    method: 'POST',
    url: 'DMS/GetUnKnownDeviceListByMacList',
    requestType: 2
  }
  let params = {}
  return $http(options, jobj)
}
//已处理的未登记设备加入或已出网络
export function SaveDhcpRequest(entity) {
  let options = {
    method: 'POST',
    url: 'DHCP/SaveDhcpRequest',
    requestType: 2
  }
  let params = {
    entity: entity
  }
  return $http(options, entity)
}
//通过mac查询 探测会话类型
export function GetSessionInfoByMac(mac) {
  let options = {
    method: 'GET',
    url: 'DMS/GetSessionInfoByMac',
    requestType: 2
  }
  let params = {
    mac: mac
  }
  return $http(options, params)
}
//通过mac查询 所有探测回话记录
export function GetSessionListDescBySnmp(mac) {
  let options = {
    method: 'GET',
    url: 'DMS/GetSessionListDescBySnmp',
    requestType: 2
  }
  let params = {
    mac: mac
  }
  return $http(options, params)
}
//通过mac和类型 获取回话记录表 vmware ,堡垒机，DHCP
export function GetCreateUnKnownDeviceSessionListBySouretype(mac, souretype) {
  let options = {
    method: 'GET',
    url: 'DMS/GetCreateUnKnownDeviceSessionListBySouretype',
    requestType: 2
  }
  let params = {
    mac: mac,
    souretype: souretype
  }
  return $http(options, params)
}
//通过回话ID和mac获取对应的网络探测信息
export function GetNetDetectInfoByMacSessionId(sessionId, mac) {
  let options = {
    method: 'GET',
    url: 'DMS/GetNetDetectInfoByMacSessionId',
    requestType: 2
  }
  let params = {
    sessionId: sessionId,
    mac: mac
  }
  return $http(options, params)
}
//通过回话ID和mac获取对应的虚拟化信息
export function GetVirtualMachineInfoByMacSessionId(sessionId, mac) {
  let options = {
    method: 'GET',
    url: 'DMS/GetVirtualMachineInfoByMacSessionId',
    requestType: 2
  }
  let params = {
    sessionId: sessionId,
    mac: mac
  }
  return $http(options, params)
}
//根据回话ID和mac 获取堡垒机探测到是设备信息
export function GetAllFortMachineInfoByMacSessionId(sessionId, mac) {
  let options = {
    method: 'GET',
    url: 'DMS/GetAllFortMachineInfoByMacSessionId',
    requestType: 2
  }
  let params = {
    sessionId: sessionId,
    mac: mac
  }
  return $http(options, params)
}
//根据回话ID和mac 获取DHCP探测到是设备信息
export function GetDhcpInfoByMacSessionId(sessionId, mac) {
  let options = {
    method: 'GET',
    url: 'DMS/GetDhcpInfoByMacSessionId',
    requestType: 2
  }
  let params = {
    sessionId: sessionId,
    mac: mac
  }
  return $http(options, params)
}
//通过回话ID+对应的Mac 获取对应的流经交换机列表
export function GetAllSwitchInfoByMac(sessionId, mac) {
  let options = {
    method: 'GET',
    url: 'DMS/GetAllSwitchInfoByMac',
    requestType: 2
  }
  let params = {
    sessionId: sessionId,
    mac: mac
  }
  return $http(options, params)
}
//获取所有snmp会话
export function GetSessionInfo() {
  let options = {
    method: 'GET',
    url: 'DMS/GetSessionInfo',
    requestType: 2
  }
  let params = {}
  return $http(options, params)
}
//获取所有snmp探测会话记录
export function GetSessionListByJob() {
  let options = {
    method: 'GET',
    url: 'DMS/GetSessionListByJob',
    requestType: 2
  }
  let params = {
    createuser: '自动探测'
  }
  return $http(options, params)
}
//获取探测会话记录
export function GetCreateUnKnownSessionListByType(soureType) {
  let options = {
    method: 'GET',
    url: 'DMS/GetCreateUnKnownSessionListByType',
    requestType: 2
  }
  let params = {
    soureType: soureType
  }
  return $http(options, params)
}
//dhcp探测记录
export function GetDetectDhcpMaster(str) {
  let options = {
    method: 'GET',
    url: 'DMS/GetDetectDhcpMaster',
    requestType: 2
  }
  let params = {
    pama: str
  }
  return $http(options, params)
}
//堡垒机探测记录
export function GetDetectFortMachineMaster(str) {
  let options = {
    method: 'GET',
    url: 'DMS/GetDetectFortMachineMaster',
    requestType: 2
  }
  let params = {
    pama: str
  }
  return $http(options, params)
}
//snmp探测记录
export function GetDetectSnmpMaster(str) {
  let options = {
    method: 'GET',
    url: 'DMS/GetDetectSnmpMaster',
    requestType: 2
  }
  let params = {
    pama: str
  }
  return $http(options, params)
}
//虚拟机探测记录
export function GetDetectVirtualMaster(str) {
  let options = {
    method: 'GET',
    url: 'DMS/GetDetectVirtualMaster',
    requestType: 2
  }
  let params = {
    pama: str
  }
  return $http(options, params)
}
//=========================一下模糊搜索接口
//dhcp探测记录
export function GetDetectDhcpMasterVague(str) {
  let options = {
    method: 'GET',
    url: 'DMS/GetDetectDhcpMasterVague',
    requestType: 2
  }
  let params = {
    pama: str
  }
  return $http(options, params)
}
//堡垒机探测记录
export function GetDetectFortMachineMasterVague(str) {
  let options = {
    method: 'GET',
    url: 'DMS/GetDetectFortMachineMasterVague',
    requestType: 2
  }
  let params = {
    pama: str
  }
  return $http(options, params)
}
//snmp探测记录
export function GetDetectSnmpMasterVague(str) {
  let options = {
    method: 'GET',
    url: 'DMS/GetDetectSnmpMasterVague',
    requestType: 2
  }
  let params = {
    pama: str
  }
  return $http(options, params)
}
//虚拟机探测记录
export function GetDetectVirtualMasterVague(str) {
  let options = {
    method: 'GET',
    url: 'DMS/GetDetectVirtualMasterVague',
    requestType: 2
  }
  let params = {
    pama: str
  }
  return $http(options, params)
}
//获取探测对象
export function GetDetectServerListBySoureType(souretype) {
  let options = {
    method: 'GET',
    url: 'DMS/GetDetectServerListBySoureType',
    requestType: 2
  }
  let params = {
    souretype: souretype
  }
  return $http(options, params)
}
